import React from "react";
import { Form } from "react-bootstrap";
import coin from  "../../assets/images/header/gem.png";


const Search = () => {
  return <div className="search-grid">

<Form>
  <Form.Group className="input-img">
    <Form.Label>Search Skin</Form.Label>
    <img src={coin} alt="" />
    <Form.Control type="email" placeholder="Name of Skin..." />
  </Form.Group>
  <Form.Group>
    <Form.Label>Min Price</Form.Label>
    <Form.Control type="email" placeholder="$0.00" />
  </Form.Group>
  <Form.Group>
    <Form.Label>Max Price</Form.Label>
    <Form.Control type="email" placeholder="$0.00" />
  </Form.Group>
  <Form.Group>
    <Form.Label>Highest Markup</Form.Label>
    <select>
      <option>3%</option>
      <option>2%</option>
      <option>1%</option>
      <option>4%</option>
    </select>
  </Form.Group>
  <Form.Group>
    <Form.Label>Sorty By</Form.Label>
    <select>
      <option>Highest Price First</option>
      <option>Highest Price First</option>
      <option>Highest Price First</option>
      <option>Highest Price First</option>
    </select>
  </Form.Group>
  </Form>

  </div>;
};

export default Search;
